import JobUserFullAdapter from 'src/helpers/adapters/JobUserFullAdapter';
export function addNewActionsToEmployee(employeesStateSlice, newActions) {
    const newEmployeesStateSlice = JSON.parse(JSON.stringify(employeesStateSlice));
    newActions.forEach((action) => {
        const employeeId = action.UserId;
        const userJob = JobUserFullAdapter.toDalUserJob(action);
        const ofUserInfo = newEmployeesStateSlice.userInfo;
        if (ofUserInfo)
            ofUserInfo.UserJobs = [...(ofUserInfo.UserJobs || []), action];
        const ofAllEmployees = newEmployeesStateSlice.allEmployees.find((employee) => employee.UserId === employeeId);
        if (ofAllEmployees)
            ofAllEmployees.UserJobs = [...(ofAllEmployees.UserJobs || []), userJob];
        const ofListEmployees = newEmployeesStateSlice.list.find((employee) => employee.UserId === employeeId);
        if (ofListEmployees)
            ofListEmployees.UserJobs = [...(ofListEmployees.UserJobs || []), userJob];
    });
    return newEmployeesStateSlice;
}
